import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CloseButton from '../CloseButton';
import {
  BreakPoint,
  Color,
  FontSize,
  Font,
  Coordinates,
} from '../../styles/constants';
import checkmarkGreen from '../../images/checkmarkGreen';

const Box = styled.div`
  background-color: ${Color.white};
  border-top: solid 1px ${Color.border.green};
  box-sizing: border-box;
  color: ${Color.text.black};
  font-family: ${Font.default};
  padding: 16px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  @media (min-width: ${BreakPoint.desktop}) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
    width: 456px;
    bottom: 32px;
    top: auto;
    left: auto;
    right: ${Coordinates.right};
    padding-top: 16px;
  }

  * {
    font-family: ${Font.default};
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: ${BreakPoint.desktop}) {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
`;

const Icon = styled.div`
  background: url(${checkmarkGreen}) no-repeat center center;
  background-size: 21px 16px;
  height: 16px;
  width: 21px;
  margin-top: 8px;

  @media (min-width: ${BreakPoint.desktop}) {
    background-size: 14px 10px;
    height: 10px;
    width: 14px;
  }
`;

const Title = styled.div`
  color: ${Color.text.green};
  flex: 1;
  font-size: ${FontSize.medium};
  font-weight: 700;
  margin-top: 8px;
  margin-left: 16px;

  @media (min-width: ${BreakPoint.desktop}) {
    margin-left: 8px;
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

const Close = styled.div`
  align-self: start;
  margin-left: 16px;
`;

const Message = styled.div`
  color: ${Color.text.black};
  font-size: ${FontSize.medium};
  margin-top: 8px;
  margin-right: 36px;

  @media (min-width: ${BreakPoint.desktop}) {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    margin-top: 16px;
  }
`;

const Alert = props =>
  props.isOpen && (
    <Box className={props.className}>
      <Header>
        <Icon />
        <Title>{props.title}</Title>
        <Close>
          <CloseButton onClick={props.onCloseClick} color="red" />
        </Close>
      </Header>
      <Message>{props.message}</Message>
    </Box>
  );

Alert.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func,
  isOpen: PropTypes.bool,
};

Alert.defaultProps = {
  onCloseClick: () => {},
  isOpen: false,
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/Alert/index.jsx